import React from 'react';
import FileUploadModal from 'components/molecules/csvUploadModal';
import dataService from 'services/dataService';
import { useTranslation } from 'react-i18next';
import { showResult } from 'infrastructure/hooks/utils';

interface IProps {
  opened: boolean;
  campaignGuid: string;
  onClose: () => void;
}

const CampaignsCsvUpload: React.FC<IProps> = ({
  opened,
  campaignGuid,
  onClose,
}) => {
  const { t } = useTranslation();

  const uploadCsvFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const { error, data } = await dataService.uploadFile(
      `core-2/patients/sms-campaign/${campaignGuid}/progress`,
      formData,
      'POST',
    );

    if (error) {
      return { error };
    }

    if (data) {
      showResult();
      onClose?.();
    }
    return {};
  };

  return (
    <FileUploadModal
      isOpen={opened}
      toggle={onClose}
      title={t('labels.uploadSmsCampaignPatients')}
      sampleFileUrl="/csvTemplates/smsCampaignTemplate.csv"
      uploadCsvFile={uploadCsvFile}
    />
  );
};

export default CampaignsCsvUpload;
